import './PaymentFinePrint.css';
import React from 'react';
import {
  DowngradePlanPaymentFinePrint,
  GeneralMarketPaymentFinePrint,
  SheerPaymentFinePrint,
  UpgradePlanPaymentFinePrint,
} from 'Components/FinePrint';
import { isDowngradeSubscription } from 'Utils/Subscriptions';
import { SHEER_FIRST_RESPONDER_TYPE, SHEER_MILITARY_TYPE } from 'Utils/Constants';

export const PaymentFinePrint = ({
  purchaseMode = {},
  ctaText,
  sheerIdProgram,
  isVaUser,
  subscription,
  selectedPlan,
}) => {
  let fineprint;

  if (sheerIdProgram === SHEER_MILITARY_TYPE || isVaUser || sheerIdProgram === SHEER_FIRST_RESPONDER_TYPE) {
    fineprint = <SheerPaymentFinePrint ctaText={ctaText} />;
  } else if (purchaseMode.isChangePlan) {
    if (isDowngradeSubscription(subscription, selectedPlan)) {
      fineprint = <DowngradePlanPaymentFinePrint ctaText={ctaText} />;
    } else {
      fineprint = <UpgradePlanPaymentFinePrint ctaText={ctaText} />;
    }
  } else {
    fineprint = <GeneralMarketPaymentFinePrint ctaText={ctaText} />;
  }

  return <div className="paymentFinePrintWrapper">{fineprint}</div>;
};
